<template>
  <section class="auth--background">
    <div class="auth--inner">
      <template v-if="!added">
        <h3>Adding your team to Worklogs</h3>
        <div class="slack-loader"></div>
      </template>
      <template v-else>
        <h3>Your team has been added</h3>
        <!--<a href='https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2F%23%2Fslackauth&state=2a745b37' class="kuzco-green button is-primary">Sign in with Slack</a>-->
        <a href='https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackauth&state=2a745b37' class="kuzco-green button is-primary">Sign in with Slack</a>
      </template>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { store } from '../store/store';
  import router from 'vue-router'

  export default {
    name: 'SlackAuth',
    data () {
      return {
        username: '',
        useremail: '',
        team: '',
        added: false
      }
    },
    mounted () {
      var self = this;
      var getQueryString = function ( field, url ) {
        var href = url ? url : window.location.href;
        var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
        var string = reg.exec(href);
        return string ? string[1] : null;
      }

      var _code = getQueryString('code')
      var _state = getQueryString('state')

      axios.get('https://api.kuzcoapp.com/slack/team/redirect?code=' + _code + '&state=' + _state)
        .then(function (response) {
          var _status = true
          self.added = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $button: #00d1b2;
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .kuzco-green {
    background-color: $kuzcogreen !important;
    font-size: 15px;
    margin: 0 auto;
    display: flex;
    width: 150px;
  }
  .auth--background{
    .slack-loader {
      margin: 0 auto;
      display: flex;
      /*display: inline-block;*/
      /*margin: 0 15px;*/
      font-size: 6px;
      text-indent: -9999em;
      width: 4em;
      height: 4em;
      border-radius: 50%;
      background: #ffffff;
      background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      position: relative;
      -webkit-animation: load3 1.4s infinite linear;
      animation: load3 1.4s infinite linear;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
    }
    .slack-loader:before {
      width: 50%;
      height: 50%;
      background: $kuzcogreen;
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
    }
    .slack-loader:after {
      background: #ffffff;
      width: 75%;
      height: 75%;
      border-radius: 50%;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    @-webkit-keyframes load3 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @keyframes load3 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
  .auth--inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h3 {
      font-size: 25px;
      margin-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// SlackAdd.vue?cd83a5e2